import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Image from 'components/Image'

import styles from './CarouselItem.module.scss'

export default function CarouselItem({ children, className, image }: props) {
  return (
    <li className={classNames('CarouselItem', className)}>
      {image &&
        // <Image src={image} uk-cover="true" />
        <Image src={image} cover className={styles.img} />
      }
      {children &&
        <div className="uk-position-cover uk-flex uk-flex-bottom uk-flex-right uk-padding">
          <div className="uk-overlay uk-tile-default">
            {children}
          </div>
        </div>
      }
    </li>
  )
}

CarouselItem.propTypes = {
  children: PropTypes.any.isRequired,
  className: PropTypes.string,
  image: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/CarouselItem/CarouselItem.js